import styled from 'styled-components';

interface HeaderContainerProps {
  disabled?: boolean;
}

export const HeaderContainer = styled.div<HeaderContainerProps>`
  cursor: pointer;
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
`;

export const Header = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px;

  @media (max-width: 580px) {
    padding: 16px;
  }
`;

interface TitleProps {
  open?: boolean;
}

export const Title = styled.div<TitleProps>`
  font-size: 23px;
  font-weight: 700;
  line-height: 27px;
  text-align: left;
  color: '#333333';

  @media (max-width: 580px) {
    font-size: 28px;
    line-height: 34px;
  }
`;

interface AccordionContentProps {
  open: boolean;
  contentHeight: number;
}

export const ContentContainer = styled.div<AccordionContentProps>`
  overflow: hidden;
  transition: height 0.1s ease-out;
  height: ${({ open }) => (open ? `fit-content` : '0')};
`;

export const Content = styled.div`
  position: relative;
`;
